import React from 'react';
import { isReactComponent } from '../../crud-core/utils/TypescriptUtils';
import * as H from 'history';
import { parse, stringify } from 'query-string';
import { addNamespaceToUrlFilters } from '../Utils/namespaceUrlFilters';
import { computeFiltersFromUrl } from '../Utils/urlFilters';
import { lensPath, view, set, Lens } from 'ramda';

type FiltersProps = {
  namespace?: string;
  addFilter?: Function;
  afterLocationSearchChange?: Function;
  onFiltersChange?: (filters: Object) => void;
  history?: H.History;
  location?: H.Location;
  path?: string;
  filters?: Object;
};

class Filters extends React.Component<FiltersProps> {
  addFilterParams = (values: Record<string, string | string[]>) => {
    const { history, location, path, namespace } = this.props;
    if (history && location) {
      const { search } = location;
      history.push({
        pathname: path,
        search: stringify(
          Object.assign({}, parse(search), addNamespaceToUrlFilters(values, namespace)),
          {
            encode: true,
          },
        ),
      });
    }
  };

  handleOnChange = (field: string, value: string | string[]) => {
    this.addFilterParams({
      [field]: value,
    });
  };

  render() {
    const { children, location, namespace } = this.props;
    const filters = computeFiltersFromUrl(location, namespace);

    return React.Children.map(children, (child) => {
      if (!child || !isReactComponent(child)) {
        return;
      }

      const filterProps = {
        key: child.props.name,
        onChange: this.handleOnChange,
        item: filters,
      };
      let childProps = { ...child.props };
      if (child.props.field) {
        childProps = {
          ...childProps,
          ...filterProps,
        };
      } else if (child.props.children) {
        let lensToChildrenProps: Lens = lensPath(['children', 'props']);
        const childrenProps: any = view(lensToChildrenProps, child.props);
        if (childrenProps.field) {
          childProps = set(
            lensToChildrenProps,
            {
              ...childrenProps,
              ...filterProps,
            },
            childProps,
          );
        }
      }

      return React.cloneElement(child, childProps);
    });
  }
}

export default Filters;
